import React from 'react';
import {
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
} from '@mui/material'; 
import GenericTooltip from '../../../../../platform/components/common/genericToolTip';
const Privacy = (props) => {
  const { 
    visibility,
    handleChange,
    isDisabled,
    isVisibleOnBookingPage,
    handleVisibleOnBookingPageChange,
    isOnBookingPageDisabled,
    tooltipData,
    bookingTypeCategoryName
  } = props;

  return (
    <Box
      sx={{
        padding: '40px 50px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        maxWidth: '400px',
        gap: '10px',
      }}
    >
      <Typography className="font">
        This {`${bookingTypeCategoryName}`} is
      </Typography>
      <Box sx={{ display: 'flex', gap: '7px', alignItems: 'center' }}>
        
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '7px', alignItems: 'center' }}>
          <RadioGroup
            name="visibility"
            value={visibility}
            onChange={handleChange}
            row
          >
            <FormControlLabel
              disabled={isDisabled}
              value="publicForStaff"
              control={<Radio />}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="body2" sx={{ margin: 0 }}>  {/* Removed margin for better alignment */}
                    Public to staff
                  </Typography>
                  <GenericTooltip title={tooltipData.visibilityToAllStaff} />
                </Box>
              }
            />
            <FormControlLabel
              disabled={isDisabled}
              value="private"
              control={<Radio />}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="body2" sx={{ margin: 0 }}> {/* Removed margin for better alignment */}
                    Private
                  </Typography>
                  <GenericTooltip title={tooltipData.visibilityToAssignedStaff} />
                </Box>
              }
            />
          </RadioGroup>
        </Box>

      </Box>

      <FormControlLabel
        control={
          <Checkbox
            sx={{
              padding: 1,
              '&:hover': { bgcolor: 'transparent' },
            }}
            color="default"
            checked={isVisibleOnBookingPage}
            onChange={handleVisibleOnBookingPageChange}
            inputProps={{ 'aria-label': 'Display on Booking Page' }}
            disabled={isDisabled || isOnBookingPageDisabled}
          />
        }
        label={
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: 8 }}>Display on Booking Page</span>
            <GenericTooltip title={tooltipData.displayOnBookingPage} />
          </Box>
        }
      />
    </Box>
  );
};

export default Privacy;
